/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment, useState, useCallback, useEffect } from "react";
import { TextField } from "@mui/material";
import { SimplicityComposerEnsureTipTap } from "cms/rich-text/simplicity-composer-tiptap/index";
import { debounce } from "lodash";
// import {defaultRichTextObjectPM} from 'cms/fields/field-component/content_zone/defaults'
import { FormLabel } from "./form-label";

const TabContent = (props) => {
    
    const {
        isCurrent,
        tab,
        updateTab,
    } = props;
    const {
        guid,
        title: _title,
        richtext: _richtext
    } = tab || {};
    
    const [currentTab, setCurrentTab] = useState(tab);
    const [title, setTitle] = useState(_title);
    const [richtext, setRichtext] = useState(_richtext);
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const update = useCallback(
        debounce((guid, previous, next) => {
            setCurrentTab(previous);
            updateTab(guid, previous, next);
        }, 500),
        [updateTab]
    );
    
    useEffect(
        () => {
            const nextTab = { ...currentTab, title, richtext };
            update(guid, currentTab, nextTab);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [title, richtext]
    );
    
    const onTitleChange = (event) => {
        const newTitle = event.target.value;
        setTitle(newTitle);
    };
    const onRichTextChange = (newRichtext) => {
        setRichtext(newRichtext);
    };
    
    return (
        <Fragment>
            {isCurrent &&
                <>
                    <FormLabel text='Tab Title' />
                    <TextField
                        id='title'
                        value={title}
                        onChange={onTitleChange}
                    />
                    
                    <FormLabel text='Content' />
                    <SimplicityComposerEnsureTipTap
                        richtext={richtext}
                        onChange={onRichTextChange}
                    />
                </>
            }
        </Fragment>
    );
};

TabContent.displayName = "TabContent";
export { TabContent };
